/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Text } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'
import theme from 'config/theme'

import { ConsultaSeguimentoPerguntaStatusTagEnum } from './ConsultaSeguimentoPerguntaStatusTag'

interface ConsultaSeguimentoPerguntaStatusLabelProps {
  label: string
  status?: ConsultaSeguimentoPerguntaStatusTagEnum
}

export function ConsultaSeguimentoPerguntaStatusLabel(props: Readonly<ConsultaSeguimentoPerguntaStatusLabelProps>) {
  const { label, status } = props

  return <Text css={styles(status).label}>{label}</Text>
}

const styles = (status) => ({
  label: css`
    height: 1.5rem;
    display: inline-flex;
    align-items: center;
    color: ${getColor(status)};
    font-weight: ${status === undefined ? 'normal' : 'bold'};
  `,
})

const getColor = (status: ConsultaSeguimentoPerguntaStatusTagEnum | undefined): string => {
  if (status === undefined) {
    return theme.pallete.text.main
  } else if (status === ConsultaSeguimentoPerguntaStatusTagEnum.PASSOU) {
    return green.c30
  } else {
    return red.c30
  }
}
